import { Spinner } from "@ucl/react-library/spinner";

export default function Loader() {
  return (
    <Spinner
      size="medium"
      style={{
        bottom: "50%",
        left: "50%",
        position: "fixed",
      }}
    />
  );
}
